// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"566":"31832d1b","787":"51647728"}[chunkId] + ".chunk.js";
};